// Import jQuery
import $ from 'jquery';

window.$ = $;
import './modules/MegaMenu';
import './modules/Splide';
 import 'foundation-sites/dist/js/plugins/foundation.offcanvas.min.js';
 import 'foundation-sites/dist/js/plugins/foundation.drilldown.min.js';

 // Initialize Foundation
document.addEventListener('DOMContentLoaded', function () {
  // Initialize Foundation JavaScript components
  // This must be called AFTER jQuery and Foundation are loaded on the page.
  $(document).foundation();
        // Get the off-canvas element
        const offCanvas = document.getElementById('offCanvas');
        
        // Create a MutationObserver to watch for class changes
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.attributeName === 'class') {
                    const isOpen = offCanvas.classList.contains('is-open');
                    if (isOpen) {
                        document.documentElement.classList.add('is-off-canvas-open');
                    } else {
                        document.documentElement.classList.remove('is-off-canvas-open');
                    }
                }
            });
        });
        
        // Start observing the off-canvas element for class changes
        observer.observe(offCanvas, {
            attributes: true,
            attributeFilter: ['class']
        });
        
        // Also handle initial state
        if (offCanvas.classList.contains('is-open')) {
            document.documentElement.classList.add('is-off-canvas-open');
        }
});
